module.exports = {
	pages: [{
		"id": "1589430347663368193",
		"parentId": "0",
		"children": [{
			"id": "1589430470711664642",
			"parentId": "1589430347663368193",
			"children": [],
			"strName": "待办事件",
			"strIco": "",
			"strUrl": "toDoTasks",
			"isPopWin": 1,
			"strAuthorityGuids": "delete,export,import,insert,select,update",
			"strModPK": "toDoTasks"
		}, {
			"id": "1589430629528985601",
			"parentId": "1589430347663368193",
			"children": [],
			"strName": "历史事件",
			"strIco": "",
			"strUrl": "historicalTasks",
			"isPopWin": 1,
			"strAuthorityGuids": "delete,export,import,select,insert,update",
			"strModPK": "historicalTasks"
		}, {
			"id": "1589430778296754178",
			"parentId": "1589430347663368193",
			"children": [],
			"strName": "事件接报",
			"strIco": "",
			"strUrl": "eventManagement",
			"isPopWin": 1,
			"strAuthorityGuids": "delete,export,import,insert,update,select",
			"strModPK": "eventManagement"
		}],
		"strName": "事件处置",
		"strIco": "",
		"strUrl": "taskManagement",
		"isPopWin": 1,
		"strAuthorityGuids": "delete,export,import,insert,select,update",
		"strModPK": "taskManagement"
	}, {
		"id": "1589860086833000449",
		"parentId": "0",
		"children": [{
			"id": "1589433766486695937",
			"parentId": "1589860086833000449",
			"children": [],
			"strName": "应急资源",
			"strIco": "",
			"strUrl": "dataClassify",
			"isPopWin": 1,
			"strAuthorityGuids": "delete,export,insert,select,update,import",
			"strModPK": "dataClassify"
		}],
		"strName": "资源管理",
		"strIco": "",
		"strUrl": "resource",
		"isPopWin": 1,
		"strAuthorityGuids": "update,select,insert,import,export,delete",
		"strModPK": "resource"
	}, {
		"id": "1589786653721923586",
		"parentId": "0",
		"children": [{
			"id": "1589430863751503873",
			"parentId": "1589786653721923586",
			"children": [],
			"strName": "隐患",
			"strIco": "",
			"strUrl": "hiddenDanger",
			"isPopWin": 1,
			"strAuthorityGuids": "delete,export,import,insert,select,update",
			"strModPK": "hiddenDanger"
		}, {
			"id": "1589430938494001153",
			"parentId": "1589786653721923586",
			"children": [],
			"strName": "危险源",
			"strIco": "",
			"strUrl": "hazardSource",
			"isPopWin": 1,
			"strAuthorityGuids": "update,select,delete,insert,export,import",
			"strModPK": "hazardSource"
		}],
		"strName": "风险源",
		"strIco": "",
		"strUrl": "riskSources",
		"isPopWin": 1,
		"strAuthorityGuids": "delete,export,import,insert,select,update",
		"strModPK": "riskSources"
	}, {
		"id": "1589787377906257922",
		"parentId": "0",
		"children": [{
			"id": "1589431026565996545",
			"parentId": "1589787377906257922",
			"children": [],
			"strName": "工作日志",
			"strIco": "",
			"strUrl": "routine",
			"isPopWin": 1,
			"strAuthorityGuids": "update,select,insert,export,delete,import",
			"strModPK": "routine"
		}, {
			"id": "1589431173433745410",
			"parentId": "1589787377906257922",
			"children": [],
			"strName": "排班值班",
			"strIco": "",
			"strUrl": "shiftArrangement",
			"isPopWin": 1,
			"strAuthorityGuids": "update",
			"strModPK": "shiftArrangement"
		}],
		"strName": "日常工作",
		"strIco": "",
		"strUrl": "routineWork",
		"isPopWin": 1,
		"strAuthorityGuids": "update,select,insert,import,export,delete",
		"strModPK": "routineWork"
	}, {
		"id": "1589431821281746945",
		"parentId": "0",
		"children": [{
			"id": "1589432987004657665",
			"parentId": "1589431821281746945",
			"children": [],
			"strName": "预案管理",
			"strIco": "",
			"strUrl": "planManagement",
			"isPopWin": 1,
			"strAuthorityGuids": "delete,export,insert,import,update,select",
			"strModPK": "planManagement"
		}, {
			"id": "1589433075777101826",
			"parentId": "1589431821281746945",
			"children": [],
			"strName": "演习演练",
			"strIco": "",
			"strUrl": "drill",
			"isPopWin": 1,
			"strAuthorityGuids": "delete,import,update,select,insert,export",
			"strModPK": "drill"
		}, {
			"id": "1589433143926153217",
			"parentId": "1589431821281746945",
			"children": [],
			"strName": "演习事件",
			"strIco": "",
			"strUrl": "exerciseEvent",
			"isPopWin": 1,
			"strAuthorityGuids": "delete,export,import,insert,select,update",
			"strModPK": "exerciseEvent"
		}],
		"strName": "预案",
		"strIco": "",
		"strUrl": "planManagement",
		"isPopWin": 1,
		"strAuthorityGuids": "delete,export,import,insert,select,update",
		"strModPK": "planManagement"
	}, {
		"id": "1589433309089456130",
		"parentId": "0",
		"children": [{
			"id": "1590145734986989569",
			"parentId": "1589433309089456130",
			"children": [],
			"strName": "视频列表",
			"strIco": "",
			"strUrl": "videoList",
			"isPopWin": 1,
			"strAuthorityGuids": "delete,export,insert,import,select,update",
			"strModPK": "videoList"
		}, {
			"id": "1589433677647142914",
			"parentId": "1589433309089456130",
			"children": [],
			"strName": "视频会商",
			"strIco": "",
			"strUrl": "videoConference",
			"isPopWin": 1,
			"strAuthorityGuids": "delete,export,import,update,select,insert",
			"strModPK": "videoConference"
		},
		{
			"id": "1589433677647142915",
			"parentId": "1589433309089456130",
			"children": [],
			"strName": "视频列表",
			"strIco": "",
			"strUrl": "videoList",
			"isPopWin": 1,
			"strAuthorityGuids": "delete,export,import,update,select,insert",
			"strModPK": "videoConference"
		}
	],
		"strName": "融合通讯",
		"strIco": "",
		"strUrl": "convergedCommunication",
		"isPopWin": 1,
		"strAuthorityGuids": "delete,import,insert,export,select,update",
		"strModPK": "convergedCommunication"
	}, {
		"id": "1589433878898237442",
		"parentId": "0",
		"children": [{
			"id": "1589433954609618945",
			"parentId": "1589433878898237442",
			"children": [],
			"strName": "上报列表",
			"strIco": "",
			"strUrl": "listEventReport",
			"isPopWin": 1,
			"strAuthorityGuids": "delete,export,import,insert,select,update",
			"strModPK": "listEventReport"
		}, {
			"id": "1589435400172298242",
			"parentId": "1589433878898237442",
			"children": [],
			"strName": "待办信息",
			"strIco": "",
			"strUrl": "myRuntimeTask",
			"isPopWin": 1,
			"strAuthorityGuids": "delete,export,import,insert,select,update",
			"strModPK": "myRuntimeTask"
		}, {
			"id": "1589435517579255809",
			"parentId": "1589433878898237442",
			"children": [],
			"strName": "办结信息",
			"strIco": "",
			"strUrl": "myHistoryTask",
			"isPopWin": 1,
			"strAuthorityGuids": "delete,export,import,insert,select,update",
			"strModPK": "myHistoryTask"
		}, {
			"id": "1589435609421930498",
			"parentId": "1589433878898237442",
			"children": [],
			"strName": "配置管理",
			"strIco": "",
			"strUrl": "eventType",
			"isPopWin": 1,
			"strAuthorityGuids": "export,delete,import,insert,select,update",
			"strModPK": "eventType"
		}, {
			"id": "1589435687146577922",
			"parentId": "1589433878898237442",
			"children": [],
			"strName": "事件详情",
			"strIco": "",
			"strUrl": "handle",
			"isPopWin": 1,
			"strAuthorityGuids": "delete,export,import,insert,select,update",
			"strModPK": "handle"
		}],
		"strName": "信息中心",
		"strIco": "",
		"strUrl": "event",
		"isPopWin": 1,
		"strAuthorityGuids": "delete,export,import,insert,select,update",
		"strModPK": "event"
	}, {
		"id": "1589428338885353473",
		"parentId": "0",
		"children": [{
			"id": "1589429312366534657",
			"parentId": "1589428338885353473",
			"children": [],
			"strName": "用户管理",
			"strIco": "",
			"strUrl": "user",
			"isPopWin": 1,
			"strAuthorityGuids": "select,import,insert,update,delete,export",
			"strModPK": "user"
		}, {
			"id": "1589509785134522370",
			"parentId": "1589428338885353473",
			"children": [],
			"strName": "资源动态",
			"strIco": "",
			"strUrl": "resourceDynamics",
			"isPopWin": 1,
			"strAuthorityGuids": "delete,export,import,insert,select,update",
			"strModPK": "resourceDynamics"
		}, {
			"id": "1589429443971211266",
			"parentId": "1589428338885353473",
			"children": [],
			"strName": "角色管理",
			"strIco": "",
			"strUrl": "role",
			"isPopWin": 1,
			"strAuthorityGuids": "delete,export,import,select,update,insert",
			"strModPK": "role"
		}, {
			"id": "1589429547356610562",
			"parentId": "1589428338885353473",
			"children": [],
			"strName": "菜单管理",
			"strIco": "",
			"strUrl": "jurisdiction",
			"isPopWin": 1,
			"strAuthorityGuids": "delete,export,insert,import,select,update",
			"strModPK": "jurisdiction"
		}, {
			"id": "1589429653090820098",
			"parentId": "1589428338885353473",
			"children": [],
			"strName": "单位管理",
			"strIco": "",
			"strUrl": "company",
			"isPopWin": 1,
			"strAuthorityGuids": "delete,export,import,insert,select,update",
			"strModPK": "company"
		}, {
			"id": "1589429752139309058",
			"parentId": "1589428338885353473",
			"children": [],
			"strName": "字典管理",
			"strIco": "",
			"strUrl": "dictionaries",
			"isPopWin": 0,
			"strAuthorityGuids": "delete,export,import,insert,select,update",
			"strModPK": "dictionaries"
		}, {
			"id": "1589429878421413890",
			"parentId": "1589428338885353473",
			"children": [],
			"strName": "模型管理",
			"strIco": "",
			"strUrl": "model",
			"isPopWin": 1,
			"strAuthorityGuids": "delete,export,import,insert,select,update",
			"strModPK": "model"
		}, {
			"id": "1589429990782623746",
			"parentId": "1589428338885353473",
			"children": [],
			"strName": "部门管理",
			"strIco": "",
			"strUrl": "department",
			"isPopWin": 1,
			"strAuthorityGuids": "delete,export,import,insert,update,select",
			"strModPK": "department"
		}, {
			"id": "1589430091559165954",
			"parentId": "1589428338885353473",
			"children": [],
			"strName": "日志管理",
			"strIco": "",
			"strUrl": "systemLog",
			"isPopWin": 1,
			"strAuthorityGuids": "delete,export,import,insert,update,select",
			"strModPK": "systemLog"
		}, {
			"id": "1589430228771627009",
			"parentId": "1589428338885353473",
			"children": [],
			"strName": "网格管理",
			"strIco": "",
			"strUrl": "grid",
			"isPopWin": 1,
			"strAuthorityGuids": "delete,export,import,insert,select,update",
			"strModPK": "grid"
		}],
		"strName": "系统管理",
		"strIco": "",
		"strUrl": "information",
		"isPopWin": 1,
		"strAuthorityGuids": "delete,export,insert,import,select,update",
		"strModPK": "information"
	}]
}
